export default __webpack_public_path__ + "04d898c2a9e88b490a26cc79c773aa66.png";